<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav :selectedLanguage="selectedLanguage" page="blog" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article class="blog-article">
            <Breadcrumb />
            <header class="blog-header">
              <h1>How to Lock Conversations in GBWhatsApp Without Interrupting Chat Flow</h1>
            </header>

            <div class="blog-content">
              <div class="blog-intro">
                <img src="@/assets/blog-3-1.webp" alt="How to Lock Conversations cov" class="blog-featured-image">
                <p>Securing your private chats is essential, and <a class="jump-url" href="https://gbwhataps.com/">GBWhatsApp</a> makes it easy to lock individual conversations without disrupting your messaging experience.This ensures sensitive chats stay protected while your day-to-day communication remains seamless.</p>
              </div>

              <div class="content-section">
                <h2>Why Lock Conversations Matters</h2>
                <p>Locking conversations in GBWhatsApp prevents unauthorized access to personal or sensitive messages. Whether you share your phone occasionally or want extra privacy, this feature ensures only you can open selected chats.</p>
              </div>

              <div class="content-section">
                <h2>How to Enable Lock Conversation</h2>
                <p>Open the chat you want to secure, tap the menu, select <strong>Lock Chat</strong>, and choose a lock method—PIN, pattern, or fingerprint. GBWhatsApp keeps this process smooth, so you can continue chatting without interruptions.</p>
                <img src="@/assets/blog-3-2.webp" alt="how-to-lock-chats-in-gb-whatsapp" class="blog-content-image">
              </div>

              <div class="content-section">
                <h2>Customizing Your Lock Settings</h2>
                <p>GBWhatsApp allows flexible lock settings:</p>
                <ul>
                  <li>Assign different lock methods for each conversation</li>
                  <li>Automatically lock chats after inactivity</li>
                  <li>Hide locked chats from the main chat list for extra privacy</li>
                </ul>
              </div>

              <div class="content-section">
                <h2>Managing Notifications for Locked Chats</h2>
                <p>Even when a chat is locked, you can customize notifications. Silence alerts or hide message previews to maintain focus while staying informed about important messages.</p>
              </div>

              <div class="content-section">
                <h2>Best Practices for Secure Chat Management</h2>
                <p>Regularly back up your chats and keep GBWhatsApp updated to ensure the lock feature works effectively. Combine chat locks with overall app privacy settings for the highest security level.</p>
              </div>
            </div>

          </article>
        </main>
      </div>
    </div>
  </div>

  <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
    Download GBWhatsapp APK
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/blog/blogspc.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';

export default {
  name: 'Blog3',
  components: {
    HeadNav,
    Breadcrumb,
  },
  data() {
    return {
      pageName: 'blog-3',
      selectedLanguage: 'en',
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    goto(name) {
      this.$router.push({
        name: `${name}`
      });
    },
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhataps.com',
          appName: appname || 'GB_gbwhataps.com',
        })
        .then((res) => {
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    gotoHome(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style scoped>
.blog-article {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.blog-header {
  text-align: center;
  margin-bottom: 40px;
}

.blog-header h1 {
  font-size: 2.5em;
  color: #25D366;
  margin-bottom: 20px;
  line-height: 1.2;
}

.blog-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  color: #666;
  font-size: 0.9em;
}

.blog-meta span {
  padding: 5px 15px;
  background: #f5f5f5;
  border-radius: 20px;
}

.blog-content {
  line-height: 1.8;
  font-size: 1.1em;
}

.blog-intro {
  margin-bottom: 40px;
}

.blog-featured-image {
  width: 100%;
  max-width: 600px;
  height: auto;
  border-radius: 10px;
  margin: 0 auto 30px;
  display: block;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.blog-content-image {
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 10px;
  margin: 20px auto;
  display: block;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.content-section {
  margin-bottom: 35px;
}

.content-section h2 {
  color: #25D366;
  font-size: 1.8em;
  margin-bottom: 15px;
  border-left: 4px solid #25D366;
  padding-left: 15px;
}

.content-section p {
  margin-bottom: 15px;
  color: #333;
}

.content-section ul {
  margin: 15px 0;
  padding-left: 20px;
}

.content-section li {
  margin-bottom: 8px;
  color: #333;
}

.content-section.conclusion {
  padding: 25px;
  border-radius: 10px;
  font-style: italic;
  font-size: 1.1em;
}

.jump-url {
  color: #25D366;
  text-decoration: none;
  font-weight: bold;
}

.jump-url:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .blog-article {
    padding: 15px;
  }
  .blog-header h1 {
    font-size: 2em;
  }
  .content-section h2 {
    font-size: 1.5em;
  }
}
</style>
